(() => {
  if (window.nvCartEngraving) return;
  window.nvCartEngraving = true;
  const feeId = '62384637247818';
  let busy = false;
  function group() {
    document.querySelectorAll('.cart-items__list').forEach(list => {
      const rows = [...list.querySelectorAll('.cart-item[data-nv-variant]')];
      const engraved = rows.filter(r => r.dataset.nvEngraving && r.dataset.nvVariant !== feeId);
      const fees = rows.filter(r => r.dataset.nvVariant === feeId);
      const total = engraved.reduce((n,r) => n + Number(r.dataset.nvQuantity),0);
      const feeTotal = fees.reduce((n,r) => n + Number(r.dataset.nvQuantity),0);
      fees.forEach(r => r.dataset.nvFeeGrouped = String(total > 0 && total === feeTotal));
      const heading = list.closest('cart-drawer-component')?.querySelector('#cart-drawer-heading');
      if (heading) {
        const count = rows.filter(r => r.dataset.nvFeeGrouped !== 'true').reduce((n,r)=>n + Number(r.dataset.nvQuantity),0);
        const text = heading.textContent.trim().replace(/\(\d+\)/, '(' + count + ')');
        if (heading.textContent.trim() !== text) heading.textContent = text;
      }
    });
  }
  document.addEventListener('quantity-selector:update', async e => {
    const row = e.target.closest?.('.cart-item[data-nv-engraving]');
    if (!row?.dataset.nvEngraving) return;
    e.stopImmediatePropagation();
    const list = row.closest('.cart-items__list');
    if (busy) return;
    busy = true;
    const controls = [...list.querySelectorAll('button,input')];
    controls.forEach(c => c.disabled = true);
    try {
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw Error('Košík se nepodařilo načíst.');
      const cart = await cartResponse.json();
      const current = cart.items.find(i => i.key === row.dataset.key);
      if (!current) throw Error('Produkt v košíku se změnil. Obnovte stránku.');
      const quantity = Math.max(0, Number(e.detail.quantity));
      const initials = i => i.properties?.['Ražba'] || i.properties?.Mintage || i.properties?.engraving;
      const total = cart.items.filter(i => String(i.variant_id) !== feeId && initials(i)).reduce((n,i) => n + (i.key === current.key ? quantity : i.quantity),0);
      const fees = cart.items.filter(i => String(i.variant_id) === feeId);
      if (!fees.length) throw Error('Příplatek za ražbu chybí. Obnovte prosím košík.');
      const updates = {[current.key]: quantity};
      fees.forEach((f,index) => updates[f.key] = index === 0 ? total : 0);
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(c => c.dataset.sectionId))].join(',');
      const response = await fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.errors) throw Error(result.description || result.message || 'Množství se nepodařilo změnit.');
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:result,sourceId:'nv-cart-engraving',data:{source:'product-form-component',sections:result.sections,itemCount:result.item_count}}}));
    } catch(error) { alert(error.message); }
    finally {busy=false;controls.forEach(c=>c.disabled=false);group();}
  },true);
  let pending = false;
  new MutationObserver(() => {if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;group();});}).observe(document.documentElement,{childList:true,subtree:true});
  group();
})();
